// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ni2m","video":"styles_video__KJ3ni","hidden":"styles_hidden__3gR68","brb":"styles_brb__kS4ua"};